import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DesktopEBookVMService } from 'modules/desktop/services/desktop-ebook-vm.service';
import { environment } from 'environments/environment';
import { DesktopAppEventsService } from 'modules/app/services/desktop-app-events-service';

@Injectable()
export class AppStateHandlerService {

    private appCloseObserver = new Subject<any>();
    appCloseObservable$ = this.appCloseObserver.asObservable();

    constructor(
        private desktopEBookVMService: DesktopEBookVMService,
        private desktopAppEventsService: DesktopAppEventsService
    ) {

        // running the constructor's code only in desktop mode
        // running the code in web app was creating error as 
        // definition of BroadcastChannel was not present in window's scope
        // and in strict mode it stops the app to load in iOS devices
        if(environment.isDesktopApp){
            //Add listener on DOWNLOAD_STARTED for response of DOWNLOAD_START
            // called when user closes app and any download was in progress.
            DLS_IPCListeners.APP_CLOSE = (options) => {
                this.appCloseObserver.next(options);
            };
    
            //Add listener of APP CLOSE NOTIFICATION on app
            // called when user closes app when no download was in progress.
            DLS_IPCListeners.APP_CLOSE_NOTIFICATION = async () => {
            
                await this.generateDesktopCloseEvent();

                // force sync data with server
                this.desktopEBookVMService.syncLocalWithServer(true);
                this.desktopEBookVMService.resetVM();
            };
        }
    }

    async quitApp() {

        await this.generateDesktopCloseEvent();

        // force sync data with server
        this.desktopEBookVMService.syncLocalWithServer(true);
        this.desktopEBookVMService.resetVM();
        DLS_IPCCallers.APP_CLOSE_CONFIRMATION();


    }

    async generateDesktopCloseEvent() {

        let isUserLoggedIn = this.desktopAppEventsService.checkIfUserIsLoggedIn();

        if (!isUserLoggedIn) {
            return;
        }

        // desktop app events for session end online mode.
        let category = this.desktopAppEventsService.CONSTANTS.EVENT_CATEGORIES.SESSION;
        let action = this.desktopAppEventsService.CONSTANTS.EVENT_ACTIONS.COMPLETE;

        // current page is set in resolver of dashboard, ebook and product details. These are the only pages from where close can be called.
        let navigatedFrom = this.desktopAppEventsService.getCurrentPage();
        let navigatedTo = this.desktopAppEventsService.CONSTANTS.NAVIGATED_PAGE_NAMES.CLOSE;

        let eventObject = this.desktopAppEventsService.generateSessionEvent(
            this.desktopAppEventsService.userData.extUserId, this.desktopAppEventsService.userData.userRole, navigatedFrom, navigatedTo, action, category
        );

        await this.desktopAppEventsService.generateDesktopEvent(eventObject);
        this.desktopAppEventsService.resetUserData();

    }
}